import {Property} from '@mintdata/mint-kit/api/decorators/Property';
import {BackgroundType} from '@mintdata/mint-kit/api/models/background/BackgroundType';
import {Color} from '@mintdata/mint-kit/api/models/Color';
import {ColorWithVisibility} from '@mintdata/mint-kit/api/models/ColorWithVisibility';
import {ANumber} from '@mintdata/mint-kit/api/values/ANumber';
import {AStringEnumConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/AEnumConfig';
import {ANumberConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/ANumberConfig';
import {BeanConfig} from '@mintdata/mint-kit/impl/properties/typeConfigs/BeanConfig';

export class Background
{
    @Property<BackgroundType>({
        title: 'Background Type',
        tip: `Background Type`,
        isRequired: true,
        typeConfig: AStringEnumConfig,
        typeCtor: BackgroundType,
    })
    type:BackgroundType;

    @Property<ColorWithVisibility>({
        title: 'Solid background Color',
        tip: `Solid background Color`,
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: ColorWithVisibility,
    })
    solidColor?:ColorWithVisibility;

    @Property<ColorWithVisibility>({
        title: 'Gradient starting color',
        tip: `Gradient starting color`,
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: ColorWithVisibility,
    })
    gradientFromColor?:ColorWithVisibility;

    @Property<ColorWithVisibility>({
        title: 'Gradient ending color',
        tip: `Gradient ending color`,
        isRequired: false,
        typeConfig: BeanConfig,
        typeCtor: ColorWithVisibility,
    })
    gradientToColor?:ColorWithVisibility;

    @Property<ANumber>({
        title: 'Gradient angle',
        tip: `Gradient angle`,
        isRequired: true,
        typeConfig: ANumberConfig,
        typeCtor: ANumber,
    })
    gradientAngle?:ANumber;

    public constructor(
        type?:BackgroundType,
        solidColor?:ColorWithVisibility,
        gradientFromColor?:ColorWithVisibility,
        gradientToColor?:ColorWithVisibility,
        gradientAngle?:ANumber,
    )
    {
        this.type = type;
        this.solidColor = solidColor;
        this.gradientFromColor = gradientFromColor;
        this.gradientToColor = gradientToColor;
        this.gradientAngle = gradientAngle;
    }

    public toCss():React.CSSProperties
    {
        if( BackgroundType.solid().isEqualTo(this.type) )
        {
            const isSolidVisible = this.solidColor.visibility.value;

            let bgColor:string;

            if( isSolidVisible )
                bgColor = this.solidColor.toCssString();
            else
                bgColor = 'transparent';

            return {
                backgroundColor: bgColor,
                backgroundImage: 'none'
            };
        }
        else if( BackgroundType.gradient().isEqualTo(this.type) )
        {
            const angle = this.gradientAngle.value + 90;

            const opacity = this.solidColor.color.alpha.value;

            const isFromVisible = this.gradientFromColor.visibility.value;
            let from;

            if( isFromVisible )
            {
                const fromHex = this.gradientFromColor.color.hex.value;
                const fromAlpha = this.gradientFromColor.color.alpha.value;
                const fromColor = Color.fromHexAlpha(fromHex, fromAlpha * opacity);
                from = fromColor.toCssString();
            }
            else
                from = 'transparent';

            const isToVisible = this.gradientToColor.visibility.value;
            let to;

            if( isToVisible )
            {

                const toHex = this.gradientToColor.color.hex.value;
                const toAlpha = this.gradientToColor.color.alpha.value;
                const toColor = Color.fromHexAlpha(toHex, toAlpha * opacity);
                to = toColor.toCssString();
            }
            else
                to = 'transparent';

            return {
                backgroundColor: 'transparent',
                backgroundImage: `linear-gradient(${angle}deg, ${from} 0%, ${to} 100%)`,
                backgroundRepeat: 'no-repeat'
            };
        }
        else
        {
            return {};
        }
    }

    public static default():Background
    {
        return new Background(
            BackgroundType.solid(),
            ColorWithVisibility.white(),
            ColorWithVisibility.white(),
            ColorWithVisibility.black(),
            ANumber.fromNumber(0),
        );
    }
}
